import { HttpContext, HttpContextToken } from '@angular/common/http';

export const ERROR_HANDLER_ENABLED = new HttpContextToken<boolean>(() => false);

export function addErrorHandler(ctx = new HttpContext()): HttpContext {
  return ctx.set(ERROR_HANDLER_ENABLED, true);
}
